import { Link } from '@everlutionsk/ui-router';
import { Box, Breadcrumbs as MuiBreadcrumbs, SxProps, Theme, Typography } from '@mui/material';
import React from 'react';

interface BreadcrumbsProps {
  readonly items: readonly PageBreadcrumb[];
}

export interface PageBreadcrumb {
  readonly label: string;
  readonly to?: string;
  readonly onClick?: () => void;
}

export function PageBreadcrumbs(props: BreadcrumbsProps) {
  const sx: SxProps<Theme> = {
    color: theme => theme.brandPalette.foreground.neutralFaded
  };

  return (
    <MuiBreadcrumbs separator={'/'} sx={sx}>
      {props.items.map((item, index) => {
        if (item.to != null)
          return (
            <Link underline="hover" sx={sx} to={item.to} key={index} variant="labelXSmall">
              {item.label}
            </Link>
          );

        if (item.onClick != null)
          return (
            <Box key={index} onClick={item.onClick}>
              <Typography
                component="a"
                variant="labelXSmall"
                sx={{
                  color:
                    index === props.items.length - 1
                      ? theme => theme.brandPalette.foreground.neutral
                      : theme => theme.brandPalette.foreground.neutralFaded,
                  textDecoration: 'none',
                  cursor: 'pointer',
                  '&:hover': {
                    textDecoration: 'underline'
                  }
                }}
              >
                {item.label}
              </Typography>
            </Box>
          );

        return (
          <Typography
            sx={{
              color:
                index === props.items.length - 1
                  ? theme => theme.brandPalette.foreground.neutral
                  : theme => theme.brandPalette.foreground.neutralFaded
            }}
            key={index}
            variant="labelXSmall"
          >
            {item.label}
          </Typography>
        );
      })}
    </MuiBreadcrumbs>
  );
}
